import axios from "axios";


// development config
// const axiosInstanceMedia = axios.create({
//   baseURL: "https://cloud-dev.ubona.com/visapp/",
// });
// const axiosInstanceCustom = axios.create({
//   baseURL: "https://cloud-dev.ubona.com/customvisapp/absli_pivc/",
// });



// Prod dependencies:



const axiosInstanceMedia = axios.create({
  baseURL: "https://adityabirlaissuance.ubona.com/visapp/",
});
const axiosInstanceCustom = axios.create({
  baseURL: "https://adityabirlaissuance.ubona.com/customvisapp/absli_pivc/",
});


export const getNameApi = (call_id) => {
  console.log(call_id);
  return axiosInstanceCustom.get(`getName/${call_id}`);
};
export const getUser = (call_id) => {
  console.log(call_id);
  return axiosInstanceCustom.get(`user-data/${call_id}`);
};

export const callPlayBot = (call_id, endpoint) => {
  return axiosInstanceMedia({
    method: "GET",
    url: `${call_id}/play/template_${endpoint}`,
    headers: {
      "x-client-id": "absli_pivc",
    },
    data: {},
  });
};

export const backendApi = (call_id, input_key, input_value) => {
  let data = {
    input_key: input_key,
    input_value: input_value,
  };
  return axiosInstanceMedia({
    method: "POST",
    url: `${call_id}/submit/v1`,
    headers: {
      "x-client-id": "absli_pivc",
    },
    data,
  });
};

export const fetchCustomApi = (call_id, method, endpoint, data) => {
  return axiosInstanceCustom({
    method: method,
    headers: {
      "x-client-id": "absli_pivc",
    },
    url: endpoint,
    data,
  });
};

export const fetchCustomApiWithToken = (
  call_id,
  method,
  endpoint,
  data,
  token
) => {
  return axiosInstanceCustom({
    method: method,
    url: endpoint,
    headers: {
      "x-client-id": "absli_pivc",
      authorization: "Bearer " + token,
    },
    maxContentLength: Infinity,
    maxBodyLength: Infinity,
    data,
  });
};

export const customvisappApi = (call_id, method, endpoint, data) => {
  return axiosInstanceCustom({
    method: method,
    url: endpoint,
    data: data,
  });
};
export const apiWithToken = (call_id, method, endpoint, token) => {
  return axiosInstanceCustom({
    method: method,
    url: endpoint,
    headers: {
      authorization: `Bearer ${token}`,
    },
  });
};

export const ThankYouApi = (call_id) => {
  return axiosInstanceMedia({
    method: "GET",
    url: `${call_id}/complete/thankyou`,
    headers: {
      "x-client-id": "absli_pivc",
    },
    data: {},
  });
};

export const RecordApi = (call_id) => {
  return axiosInstanceMedia({
    method: "GET",
    url: `${call_id}/complete/record_video`,
    headers: {
      "x-client-id": "absli_pivc",
    },
    data: {},
  });
};

export const FinishApi = (call_id) => {
  return axiosInstanceMedia({
    method: "PUT",
    url: `${call_id}/finish`,
    headers: {
      "x-client-id": "absli_pivc",
    },
    data: {},
  });
};

export const SubmitActivity = (call_id, input_key, input_value) => {
  let data = {
    event_key: input_key,
    event_val: input_value,
  };

  return axios({
    method: "POST",
    url: `https://adityabirlaissuance.ubona.com/customvisapp/submitActivity/absli_pivc/${call_id}`,
    // url: `https://cloud-dev.ubona.com/customvisapp/submitActivity/absli_pivc/${call_id}`,
    headers: {
      "x-client-id": "absli_pivc",
    },
    data,
  });
};

export const LiveCallApi = (call_id) => {
  return axiosInstanceMedia({
    method: "GET",
    url: `livecall/${call_id}`,
    headers: {
      "x-client-id": "absli_pivc",
    },
    data: {},
  });
};
export const CompleteApi = (call_id, endpoint) => {
  return axiosInstanceMedia({
    method: "GET",
    url: `${call_id}/complete/${endpoint}`,
    headers: {
      "x-client-id": "absli_pivc",
    },
    data: {},
  });
};
